<template>
  <div class="elunittree">
    <!-- 新的Element单选设备树形控件 -->
    <div style="margin-bottom: 5px;">
      <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
    </div>
    <el-scrollbar style="height:calc(100% - 55px);width: 100%;">
      <el-tree class="filter-tree" :data="dataList" :default-expanded-keys="defaultExpanded"
        :expand-on-click-node="true" node-key="no" :props="defaultProps" :highlight-current='true'
        :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
        <template #default="{ node }">
          <span class="custom-tree-node">
            <img src="../../../../public/static/image/elTree/1.9.png" v-if="node.data.entityName == 'AppClassType'">
            <img src="../../../../public/static/image/elTree/2.1.png" v-else>
            <span style="margin-left:4px">{{ node.label }}</span>
          </span>
        </template>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
  export default {
    props: ['dataList'],
    data () {
      return {
        filterText: "",
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultExpanded: [],
        defaultDevice: "",
      };
    },

    mounted () {
      this.digui(this.dataList)

    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      dataList (val) {

        this.digui(val)
      }
    },
    computed: {



    },

    methods: {
      // 树形筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },
      tree_fn () {},
      nodeClick (val) {
        // console.log([val]);
        this.$emit('checkFun',[val])
        this.$emit('clickItem',[val])
      },
      digui (data) {
        var device=[]
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('children')&&row.children.length!=0) {
                getStr(row.children)
              } else {
                device.push(row)

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        this.defaultExpanded=[device[0].no]
        this.$nextTick(() => {
          //默认选中
          this.$refs['tree'].setCurrentNode(device[0]);
          this.$emit('checkFun',[device[0]]);
        })

      },
    },
  };
</script>

<style lang="scss" scoped>
  .elunittree {
    width: 100%;
    height: 100%;

    .custom-tree-node {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }
    }

  }
</style>